import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PlusCircle, X, ArrowLeft } from "feather-icons-react/build/IconComponents";
import { all_routes } from "../../Router/all_routes";

const EditCallCenter = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const callCenterId = searchParams.get("callCenterId");

  const [callCenterName, setCallCenterName] = useState("");
  const [phoneNumbers, setPhoneNumbers] = useState([""]);

  useEffect(() => {
    if (callCenterId) {
      const fetchCallCenterDetails = async () => {
        const response = {
          name: "Call Center A",
          phoneNumbers: ["+1234567890", "+0987654321"],
        };
        setCallCenterName(response.name);
        setPhoneNumbers(response.phoneNumbers);
      };
      fetchCallCenterDetails();
    }
  }, [callCenterId]);

  const handleAddPhoneNumber = () => {
    setPhoneNumbers([...phoneNumbers, ""]);
  };

  const handleRemovePhoneNumber = (index) => {
    setPhoneNumbers(phoneNumbers.filter((_, i) => i !== index));
  };

  const handlePhoneNumberChange = (index, value) => {
    const updatedPhoneNumbers = phoneNumbers.map((num, i) =>
      i === index ? value : num
    );
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const handleSave = () => {
    navigate(all_routes.callcenters);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>{callCenterId ? "Edit Call Center" : "Add New Call Center"}</h4>
          </div>
          <div className="page-btn">
            <button
              onClick={() => navigate(all_routes.callcenters)}
              className="btn btn-secondary"
            >
              <ArrowLeft className="me-2" />
              Back to Call Centers
            </button>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="mb-4">
              <label className="form-label">Call Center Name</label>
              <input
                type="text"
                className="form-control"
                value={callCenterName}
                onChange={(e) => setCallCenterName(e.target.value)}
                placeholder="Enter Call Center Name"
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Phone Numbers</label>
              {phoneNumbers.map((number, index) => (
                <div key={index} className="d-flex align-items-center mb-2">
                  <input
                    type="text"
                    className="form-control"
                    value={number}
                    onChange={(e) =>
                      handlePhoneNumberChange(index, e.target.value)
                    }
                    placeholder="Enter phone number"
                  />
                  <button
                    className="btn btn-outline-secondary ms-2"
                    onClick={() => handleRemovePhoneNumber(index)}
                  >
                    <X size={14} />
                  </button>
                </div>
              ))}
              <button
                    className="btn btn-outline-primary mt-2"
                    onClick={handleAddPhoneNumber}
              >
                <PlusCircle className="me-2 iconsize" />
                Add Phone Number
              </button>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            onClick={handleSave}
            className="btn btn-primary"
          >
            {callCenterId ? "Update Call Center" : "Add Call Center"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCallCenter;
